import { useMenuContext } from "../../mega-menu-provider";
import { MenuGroup, MenuGroupList, MenuGroupTitle, MenuLink, MenuLinkDescription, MenuLinkImage, MenuListItem, MenuWithColumnsContainer } from "./sub-menu.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var renderLabel = function renderLabel(_ref) {
  var Icon = _ref.Icon,
    imageSrc = _ref.imageSrc,
    description = _ref.description,
    label = _ref.label;
  var isMobileMenu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (Icon) {
    return /*#__PURE__*/_jsx(Icon, {});
  }
  if (!isMobileMenu && imageSrc) {
    return description;
  }
  return label;
};
var SubMenuWithColumns = function SubMenuWithColumns(_ref2) {
  var items = _ref2.items,
    palette = _ref2.palette,
    onItemClick = _ref2.onItemClick;
  var topMenuItems = items;
  var _useMenuContext = useMenuContext(),
    isMobileMenu = _useMenuContext.isMobileMenu;
  return /*#__PURE__*/_jsx(MenuWithColumnsContainer, {
    children: topMenuItems.map(function (column) {
      var _column$items;
      return /*#__PURE__*/_jsxs(MenuGroup, {
        showColumnSeparator: column.columnSeparator,
        children: [/*#__PURE__*/_jsx(MenuGroupTitle, {
          palette: palette,
          hideOnMobile: column.hideLabelOnMobile,
          children: column.label
        }), /*#__PURE__*/_jsx(MenuGroupList, {
          children: column === null || column === void 0 ? void 0 : (_column$items = column.items) === null || _column$items === void 0 ? void 0 : _column$items.map(function (menuItem) {
            return /*#__PURE__*/_jsx(MenuListItem, {
              children: /*#__PURE__*/_jsx(MenuLink, {
                onClick: function onClick(event) {
                  return onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick({
                    event: event,
                    item: menuItem
                  });
                },
                href: menuItem.href,
                target: menuItem === null || menuItem === void 0 ? void 0 : menuItem.target,
                hasImage: !!menuItem.imageSrc && !isMobileMenu,
                iconWidth: menuItem.iconWidth,
                iconHeight: menuItem.iconHeight,
                children: /*#__PURE__*/_jsxs(_Fragment, {
                  children: [!isMobileMenu && menuItem.imageSrc && /*#__PURE__*/_jsx(MenuLinkImage, {
                    width: menuItem.iconWidth,
                    height: menuItem.iconHeight,
                    src: menuItem.imageSrc
                  }), renderLabel(menuItem, isMobileMenu), !menuItem.imageSrc && menuItem.description && /*#__PURE__*/_jsx(MenuLinkDescription, {
                    palette: palette,
                    children: menuItem.description
                  })]
                })
              })
            }, menuItem.id);
          })
        })]
      }, column.id);
    })
  });
};
export default SubMenuWithColumns;